module.exports = __webpack_public_path__ + "img/icb-del-Adv-e@2x.2d576955.png";